export class AddSchoolDataDto {
    Id: number;
    Number: number;
    Name: string;
    Mail: string;
    Address: string;
    PhoneNumber: string;
    shifts: any[];

    constructor() {
        this.Id = -1;
        this.Number = -1;
        this.Name = '';
        this.Mail = '';
        this.Address = '';
        this.PhoneNumber = '';
        this.shifts = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/school-data/dto/AddSchoolDataDto.ts